module.exports = global["DraftJS"] = require("-!./Draft.js");